import { updateKey, removeIndicator } from 'piral-core';
function getNewFormState(newState, patch) {
    if (patch.active === false && !newState.submitting) {
        return removeIndicator;
    }
    return newState.active || newState.submitting || newState.changed ? newState : removeIndicator;
}
export function updateFormState(ctx, id, initial, patch) {
    ctx.dispatch((state) => {
        const newState = {
            ...initial,
            ...(state.forms[id] || {}),
            ...patch,
        };
        const updatedState = getNewFormState(newState, patch);
        return {
            ...state,
            forms: updateKey(state.forms, id, updatedState),
        };
    });
}
//# sourceMappingURL=actions.js.map